<template>
  <b-row>
    <b-col>
      <b-card>
        <template #header>
          <strong>搜尋條件</strong>
        </template>
        <b-row>
          <b-col lg="2" md="3">
            <b-form-group label="工單編號">
              <b-form-input v-model="filter.no"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="客戶編號或名稱">
              <b-form-input v-model="filter.customer"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="起始日期">
              <date-picker v-model="filter.start" valueType="format" />
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="結束日期">
              <date-picker v-model="filter.end" valueType="format" />
            </b-form-group>
          </b-col>
        </b-row>
        <template #footer>
          <b-button variant="danger" size="sm" class="float-right" @click="clearFilter()"> 清空 </b-button>
          <b-button variant="success" size="sm" class="float-right mr-1" @click="search()"> 查詢 </b-button>
        </template>
      </b-card>

      <b-card>
        <template #header>
          <strong>出貨列表</strong>
        </template>
        <b-table striped hover bordered :items="datalist" :fields="fields" show-empty>
          <template #empty>
            <h2 class="text-secondary text-center m-4">無資料</h2>
          </template>
          <template #cell(index)="row"><b-form-checkbox :checked="checkPrint(row.item.id)" @change="changePrint($event, row.item.id)" /></template>
          <template #cell(date)="row">{{ $date(row.item.date).format("YYYY-MM-DD") }}</template>
          <template #cell(total)="row">{{ $function.priceformat(row.item.total) }}</template>
          <template #cell(customerName)="row">
            {{ row.item.customerNo }} - {{ row.item.customerName ? row.item.customerName : row.item.contactName }}
            <span v-if="row.item.referrerNo && row.item.referrerName">({{ row.item.referrerNo }} - {{ row.item.referrerName }})</span>
          </template>
          <template #cell(action)="row">
            <b-button variant="primary" size="sm" :to="{ name: '收件資料', params: { id: row.item.caseId } }">詳細資料</b-button>
          </template>
        </b-table>
        <b-pagination v-model="pageinfo.page" :total-rows="pageinfo.count" :per-page="pageinfo.limit" align="center" @change="getInvoices"></b-pagination>
        <template #footer>
          <b-button variant="danger" class="float-right" @click="clearPrint()"> 清空選擇 </b-button>
          <b-button variant="success" class="float-right mr-1" @click="print()"> 合併列印 </b-button>
        </template>
      </b-card>
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
      <vue-easy-print tableShow ref="invoicePrint">
        <template slot-scope="">
          <div><print-page-invoice-multiple v-if="printData" :data="printData" /></div>
        </template>
      </vue-easy-print>
    </b-col>
  </b-row>
</template>

<script>
import VueEasyPrint from "vue-easy-print";
import PrintPageInvoiceMultiple from "@/components/print/invoicemultiple";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-tw";

export default {
  name: "",
  components: { DatePicker, VueEasyPrint, PrintPageInvoiceMultiple },
  data: () => ({
    loading: false,
    datalist: [],
    pageinfo: {
      count: 1,
      limit: 10,
      page: 1,
      totalPage: 1,
    },
    fields: [
      { key: "index", label: "列印", class: "text-center align-middle" },
      { key: "caseNo", label: "工單編號", class: "text-center align-middle" },
      { key: "date", label: "日期", class: "text-center align-middle" },
      { key: "customerName", label: "客戶名稱", tdClass: "align-middle", thClass: "text-center align-middle" },
      { key: "total", label: "金額", class: "text-center align-middle" },
      { key: "shipping", label: "出貨方式", class: "text-center align-middle" },
      { key: "shippingNo", label: "出貨單號", class: "text-center align-middle" },
      { key: "remark", label: "備註", tdClass: "align-middle", thClass: "text-center align-middle" },
      { key: "action", label: "操作", class: "text-center align-middle" },
    ],
    filter: {
      customer: "",
      no: "",
    },
    printlist: [],
    printData: null,
  }),
  mounted() {
    this.getInvoices(1);
  },
  methods: {
    clearPrint() {
      this.printlist = [];
    },
    print() {
      let params = {
        params: {
          invoiceId: this.printlist,
        },
      };
      this.$http.get("/print/invoice/multiple", params).then((response) => {
        if (response.data.success) {
          this.printData = response.data.result;
          this.$nextTick(() => this.$refs.invoicePrint.print());
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
      });
    },
    changePrint(event, id) {
      if (event) this.printlist.push(id);
      else this.printlist.splice(this.printlist.indexOf(id), 1);
    },
    checkPrint(id) {
      return this.printlist.includes(id);
    },
    clearFilter() {
      this.pageinfo.page = 1;
      this.filter.customer = "";
      this.filter.no = "";
      this.filter.start = "";
      this.filter.end = "";
      this.search();
    },
    search() {
      this.pageinfo.page = 1;
      this.getInvoices();
    },
    getInvoices(page = null) {
      this.loading = true;
      let params = {
        params: {
          page: page === null ? this.pageinfo.page : page,
          customer: this.filter.customer,
          no: this.filter.no,
          start: this.filter.start,
          end: this.filter.end,
        },
      };
      this.$http.get("/invoice/clist", params).then((response) => {
        if (response.data.success) {
          this.datalist = response.data.result.datalist;
          this.pageinfo = response.data.result.pageinfo;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
  },
};
</script>